<script>
import { mapGetters } from 'vuex'

export default {
  name: 'RemoteControlBlocker',
  computed: {
    ...mapGetters({
      uiBlockedRemotely: 'getRemoteBlockerStatus',
      deviceId: 'getDeviceId'
    })
  },
  mounted() {
    this.$cable.subscribe({
      channel: 'BlockerChannel',
      device_id: `${this.deviceId}`
    })
  },
  channels: {
    BlockerChannel: {
      connected() {
        console.log(
          '%c Connected to BlockerChannel from RemoteControlBlocker',
          'color: deepskyblue'
        )
      },
      received(data) {
        this.handleIncomingData(data)
      }
    }
  },
  methods: {
    handleIncomingData(data) {
      console.log('BlockerChannel data', data)
      data ? this.$blockUIRemotely() : this.$unblockUIRemotely()
    }
  }
}
</script>

<template lang="pug">
transition(name="fade" v-if="uiBlockedRemotely")
  .blocker
    .blocker-inner {{ $t('remoteControlBlockerInfo') }}
</template>

<style scoped lang="scss">
@import '@/assets/styles/variables.scss';

.blocker {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;

  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9998;

  .blocker-inner {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60vw;
    height: 20rem;
    border-radius: 3rem;
    background: #fff;
    padding: 3rem;
    text-align: center;
  }
}

.fade-enter-active {
  transition: opacity 0.3s;
}

.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
